import { createCrudActions } from '../utils/crudGenerator';

const formatTypeeats = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchTypeeats,
    create: createTypeeat,
    update: updateTypeeat,
    delete: deleteTypeeats
} = createCrudActions('TYPEEAT', "TipoComida", formatTypeeats);